import UbsApiV2 from "./UbsApiV2";

export const getNotificationTemplates = async () => {
  const respones = await UbsApiV2.get("/ssc/notification/templates")
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errResposne = {};
      if (error.respone !== undefined) {
        errResposne = error.respone;
      } else {
        errResposne = "Network Error";
      }
      return errResposne;
    });
  return respones;
};

export const getNotificationEventTypes = async () => {
  const responses = await UbsApiV2.get("/ssc/notification/event/types")
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorResponse = "Network error";

      if (error.response !== undefined) {
        errorResponse = error.respone;
      }
      return errorResponse;
    });
  return responses;
};

export const getNotificationTypes = async () => {
  const responses = await UbsApiV2.get("/ssc/notification/types")
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorResponse = "Network error";

      if (error.response !== undefined) {
        errorResponse = error.respone;
      }
      return errorResponse;
    });
  return responses;
};

export const createNotificationTemplate = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const response = await UbsApiV2.post(`/ssc/notification/templates`, payload, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
  return response;
};

export const updateNotificationTemplate = async (id, payload) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await UbsApiV2.put(
    `/ssc/notification/templates/${id}`,
    payload,
    {
      headers: headers,
    },
  )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
  return response;
};

export const deleteNotificationTemplate = async (id) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await UbsApiV2.delete(`/ssc/notification/templates/${id}`, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
  return response;
};
